import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ConfirmDialogProps } from 'types/Dialog.types';

/**
 * ConfirmDialog component used in the TableOfContents view for deleting pages from a deck,
 * save changes before switching to scenario management
 * @param props.isDialogOpen - Boolean to control the open state of the dialog
 * @param props.setIsDialogOpen - Function to set the open state of the dialog
 * @param props.handleConfirm - Function to handle the confirmation
 * @constructor
 */
const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    isDialogOpen,
    setIsDialogOpen,
    handleConfirm,
    handleCancel,
    dialogText,
    confirmText = 'Yes, Delete',
    cancelText = 'Cancel',
    dialogTitle,
  } = props;

  return (
    <Dialog
      className='confirm-dialog'
      open={isDialogOpen ?? false}
      onClose={() => {
        if (setIsDialogOpen) {
          setIsDialogOpen(false);
        }
      }}
      aria-labelledby='dialog-title'
      aria-describedby='dialog-description'
    >
      <DialogTitle id='dialog-title'>{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id='dialog-description'>{dialogText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className='dialog-button cancel-button'
          onClick={() => {
            if (handleCancel) {
              handleCancel();
            } else if (setIsDialogOpen) {
              setIsDialogOpen(false);
            }
          }}
        >
          {cancelText}
        </Button>
        <Button className='dialog-button confirm-button' onClick={handleConfirm} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
